import React from 'react';

const NoFiles = ({message = "No files"}) => {
    return (
        <div className={"no-files col-12 border-top border-bottom py-3 text-eh-off-black text-center"}>
            {message}
        </div>
    );
}

export default NoFiles;
